import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    tokensafiro: "",
    adminsafiro: []
  },
  mutations: {
    login(state, data) {
      state.adminsafiro = data.user;
      state.tokensafiro = data.token;
    },
    logout(state) {
      state.sesion = [];
      state.adminsafiro = [];
      state.tokensafiro = "";
    },
    adminsafiro(state, data) {
      state.adminsafiro = data;
    }
  },
  actions: {
    login({ commit }, data) {
      commit("login", data);
    },
    logout({ commit }) {
      commit("logout");
    },
    setuser({ commit }, data) {
      commit("adminsafiro", data);
    }
  }
});
